import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getFeatureDetails } from 'src/redux/async/electronicTool/electronicTool'

const initialState = {
  featureDetailsLoader: false,
  featureDetailsError: '',
  feature_details: null,
}

export const featureDetailsSlice = createSlice({
  name: 'electronic-tool/get-feature-details-and-franch',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getFeatureDetails.pending), (state) => {
      state.featureDetailsLoader = true
    })
    builder.addMatcher(isAnyOf(getFeatureDetails.fulfilled), (state, action) => {
      state.featureDetailsLoader = false
      state.feature_details = action.payload
      state.featureDetailsError = ''
    })
    builder.addMatcher(isAnyOf(getFeatureDetails.rejected), (state, action) => {
      state.featureDetailsLoader = false
      state.featureDetailsError = action.payload
    })
  },
  reducers: {
    emptyFeatureDetailsSlice: (state) => {
      state.featureDetailsLoader = false
      state.featureDetailsError = ''
      state.feature_details = {}
    },
  },
})

// export const { emptyelectronicComponentDetailsSlice } = electronicComponentDetailsSlice.actions;

export default featureDetailsSlice.reducer
